import { Icon, Tabs } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './detailTabBar.module.css';

export type DetailTabItem = {
  value: string;
  label: string;
  icon: IconComponent;
  dataCy?: string;
};

type DetailTabBarProps = {
  tabs: DetailTabItem[];
  activeTab: string;
  onChange: (value: string) => void;
  dataCy?: string;
};

const styles = {
  tabs: {
    minHeight: 'unset',
    '& .MuiTabs-indicator': {
      backgroundColor: colors.neutral.white,
      height: '2px',
    },
  },
  tab: {
    color: colors.neutral.white,
    opacity: 0.4,
    width: '5.125rem',
    minWidth: '5.125rem',
    minHeight: 'unset',
    padding: '0.25rem 0 0.6rem',
    marginRight: '1.25rem',
    '&.Mui-selected': {
      color: colors.neutral.white,
      opacity: 1,
    },
  },
};

const DetailTabBar = ({
  tabs,
  activeTab,
  onChange,
  dataCy,
}: DetailTabBarProps) => (
  <Tabs
    value={activeTab}
    onChange={(_, value) => onChange(value)}
    variant="scrollable"
    allowScrollButtonsMobile
    sx={styles.tabs}
    data-cy={dataCy}
  >
    {tabs.map(tab => (
      <Tabs.Tab
        key={tab.value}
        value={tab.value}
        data-cy={tab.dataCy}
        sx={styles.tab}
        label={
          <>
            <Icon color={colors.neutral.white} icon={tab.icon} />
            <div className={classes.label}>{tab.label}</div>
          </>
        }
      />
    ))}
  </Tabs>
);

export default DetailTabBar;
